// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

export const extractVimeoID = url => {
  const regExp = /(?:vimeo\.com\/)(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[3] : null;
};

export const extractDailymotionID = url => {
  const regExp = /(?:dailymotion\.com\/(?:video|hub)|dai\.ly)\/([a-zA-Z0-9]+)/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

export const detectVideoType = url => {
  if (!url) return null;

  if (extractYouTubeID(url)) return 'youtube';
  if (extractVimeoID(url)) return 'vimeo';
  if (extractDailymotionID(url)) return 'dailymotion';

  // Check for direct video file
  const videoExtensions = /\.(mp4|webm|ogg|mov)(\?|$)/i;
  if (videoExtensions.test(url)) return 'direct';

  // For any other URL that might be embeddable
  return 'generic';
};
